// extracted by mini-css-extract-plugin
export var fadeIn = "QuoteAndVideo-module--fadeIn--kimW7";
export var label = "QuoteAndVideo-module--label--BUyVM";
export var load = "QuoteAndVideo-module--load--FbBaS";
export var quote = "QuoteAndVideo-module--quote--ZEbrD";
export var quoteContent = "QuoteAndVideo-module--quoteContent--01nt8";
export var video = "QuoteAndVideo-module--video--n0S8b";
export var videoFade = "QuoteAndVideo-module--videoFade--MJZsT";
export var videoWrapper = "QuoteAndVideo-module--videoWrapper--v6LBB";
export var wrapper = "QuoteAndVideo-module--wrapper--AELsk";